import { render, staticRenderFns } from "./TintHistory.vue?vue&type=template&id=195d3896&scoped=true"
import script from "./TintHistory.vue?vue&type=script&lang=js"
export * from "./TintHistory.vue?vue&type=script&lang=js"
import style0 from "./TintHistory.vue?vue&type=style&index=0&id=195d3896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d3896",
  null
  
)

export default component.exports